(function ($) {
  'use strict';

  const ARIA_EXPANDED = 'aria-expanded';
  const ARIA_HIDDEN = 'aria-hidden';
  const CLASS_OPEN = 'open';
  const ATTR_TRUE = 'true';
  const ATTR_FALSE = 'false';

  $(document).ready(function () {
    $('#toggle-navigation').on('click', function () {
      const $btn = $(this);
      const isOpen = $btn.hasClass(CLASS_OPEN);

      $btn.toggleClass(CLASS_OPEN);
      if (isOpen) {
        $btn.attr(ARIA_EXPANDED, ATTR_FALSE);
      } else {
        $btn.attr(ARIA_EXPANDED, ATTR_TRUE);
      }
      $btn.siblings('.navigation').toggleClass('d-none');
    });

    $('.accordion-menu .accordion-toggle').on('click', function () {
      const $btn = $(this);
      const $submenu = $btn.siblings('ul');
      const isOpen = $btn.hasClass(CLASS_OPEN);

      // Toggle state
      $btn.parent().toggleClass('active');
      $btn.toggleClass(CLASS_OPEN);
      $submenu.toggleClass('d-block');

      // Sync ARIA attributes
      if (isOpen) {
        $btn.attr(ARIA_EXPANDED, ATTR_FALSE);
        $submenu.attr(ARIA_HIDDEN, ATTR_TRUE);
      } else {
        $btn.attr(ARIA_EXPANDED, ATTR_TRUE);
        $submenu.attr(ARIA_HIDDEN, ATTR_FALSE);
      }
    });
  });
})(jQuery);
